export default {
  UP_TO_AMOUNT: "up_to_amount",
  EXACT_AMOUNT: "exact_amount"
};
